import { useProfile } from '@shared/api/useProfile';
import s from './settings.module.scss'
import { IconChevronRight } from '@tabler/icons-react';
import { NavLink } from 'react-router-dom';
import useMedia from 'use-media';
import { PageTemplate } from '@shared/ui/page-template';
import { getFullName } from '@utils/lib/getFullname';
import { SettingsForm } from '@pages/settings/settings-form/settings-form';
import { VideoSettings } from '@pages/settings/video-settings/video-settings';
import { Notifications } from '@pages/settings/notification-settings/notification';
import { UpdatePassword } from '@pages/settings/update-password/update-password';
import { AppearanceSettings } from '@pages/settings/appearance-settings';
import { Tab, Tabs } from '@shared/ui/tabs/tabs';
import { auth } from '@shared/api/services';
import { TimezoneButton } from '@features/profile/timezone';
import { SupportButton } from '@shared/ui/support-button';
import { version } from 'info';
import classNames from 'classnames';

export const Settings = () => {
	const isMobile = useMedia({maxWidth: '768px'})
	const {data: profile} = useProfile()

	return (
		<PageTemplate title='Настройки'>
			{isMobile ? <div className={s.menu}>
				<div className={s.profile}>
					<div className={s.avatar}>
						<img src={profile.avatar ? process.env.REACT_APP_STORAGE_URL + profile.avatar.image : process.env.REACT_APP_STORAGE_URL + 'images/default_avatar.png'} alt="" />
					</div>
					<div className={s.profileContent}>
						<div className={s.mail}>Профиль</div>
						<div className={s.name}>{getFullName(profile)}</div>
					</div>
				</div>
				<div className={s.menuList}>
					<TimezoneButton/>
				</div>
				<div className={s.menuList}>
					<NavLink className={s.menuItem} to="./profile">Профиль<IconChevronRight size={16} color='#888'/></NavLink>
					<NavLink className={s.menuItem} to="./video-and-audio">Видео и аудио<IconChevronRight size={16} color='#888'/></NavLink>
					<NavLink className={s.menuItem} to="./notifications">Уведомления<IconChevronRight size={16} color='#888'/></NavLink>
					<NavLink className={s.menuItem} to="./security">Безопасность<IconChevronRight size={16} color='#888'/></NavLink>
					<NavLink className={s.menuItem} to="./appearance">Внешний вид<IconChevronRight size={16} color='#888'/></NavLink>
					<NavLink className={s.menuItem} to="/info">Информация<IconChevronRight size={16} color='#888'/></NavLink>
				</div>
				<div className={s.menuList}>
					<SupportButton label="Написать в поддержку"
						// shape="pill"
						theme="secondary"
						buttonClassName={classNames(s.menuItem,s.supportButton)}/>
				</div>
				<div className={s.menuList}>
					<NavLink className={s.logout} onClick={() => auth.logout()}>Выйти</NavLink>
				</div>
				<div className={s.version}>Версия {version}</div>
			</div> : 
				<Tabs className={s.tabs} options={[
					{label: 'Профиль', key: 1},
					{label: 'Видео и Аудио', key: 2},
					{label: 'Уведомления', key: 3},
					{label: 'Безопасность', key: 4},
					{label: 'Внешний вид', key: 5},
					]}>
					<Tab key="tab-1">
						<SettingsForm/>
					</Tab>
					<Tab key="tab-2">
						<VideoSettings />
					</Tab>
					<Tab key="tab-3">
						<Notifications/>
					</Tab>
					<Tab key="tab-4">
						<UpdatePassword/>
					</Tab>
					<Tab key="tab-5">
						<AppearanceSettings/>
					</Tab>
				</Tabs>
			}
		</PageTemplate>
	)
}